import axios from '../plugins/axios';

export default async function check(email) {
  const response = await axios(
    '/admin-user/email-exist-checker',
    { params: { email: email } },
    {
      method: 'GET',
    }
  );
  return response;
}
